import React, { Dispatch, SetStateAction } from 'react';
import { numberFormatter } from '../../../../../utils/helpers/numberFormater';
import { Button, Spinner } from 'react-bootstrap';
import { downloadFileRequest } from '../../../../../utils';
import { BASE_URL } from '../../../../../utils/endpoints';
import { useTranslation } from 'react-i18next';
import { DiscoveryUser } from '../dto/IDiscoveryFilter';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../../../store/rootReducer';
import { openUpgradeModal } from '../../../../../store/subscription/subscriptionSlice';

interface IDiscoveryTotalSectionProps {
    hasSearched: boolean;
    activePlatform: string;
    setIsLoading: Dispatch<SetStateAction<boolean>>;
    isLoading: boolean;
    lookalikes?: DiscoveryUser[];
    total?: number;
    favoritesCount?: number;
    goToFavorites?: () => void;
    goToLists?: () => void;
    listsCount?: number;
    isDiscoveryLimited?: boolean;
    openUpgradeModal?: () => void;
}

const DiscoveryTotalsSection = ({
    hasSearched,
    goToFavorites,
    activePlatform,
    favoritesCount,
    setIsLoading,
    isLoading,
    lookalikes,
    total,
    goToLists,
    listsCount,
    openUpgradeModal,
    isDiscoveryLimited,
}: IDiscoveryTotalSectionProps) => {
    const { t } = useTranslation();

    return (
        <>
            {hasSearched && (
                <div className="d-md-flex justify-content-md-between mt-4 mb-md-0 mb-3">
                    <p className="font-16">
                        Total <span className="font-weight-bold font-16">{numberFormatter(total ?? 0)}</span>{' '}
                        influencers found on{' '}
                        <span className="font-weight-bold font-16">{activePlatform?.toUpperCase()}</span>
                    </p>
                    <div onClick={openUpgradeModal}>
                        {!!goToFavorites && (
                            <Button
                                disabled={isDiscoveryLimited}
                                onClick={goToFavorites}
                                className="mr-3"
                                variant="outline-primary"
                            >
                                {t('brand.campaign.discovery.favorite', { nbFavorite: favoritesCount })}
                            </Button>
                        )}
                        {!!goToLists && (
                            <Button
                                disabled={isDiscoveryLimited}
                                onClick={goToLists}
                                className="mr-3"
                                variant="outline-primary"
                            >
                                {t('brand.campaign.discovery.open_lists', { listsCount })}
                            </Button>
                        )}
                        <Button
                            variant="outline-primary"
                            onClick={() =>
                                downloadFileRequest(
                                    BASE_URL + 'brand/discovery/export/modash',
                                    null,
                                    { users: lookalikes },
                                    setIsLoading
                                )
                            }
                            disabled={isLoading || !lookalikes?.length || isDiscoveryLimited}
                        >
                            {isLoading ? (
                                <>
                                    Generating export...{' '}
                                    <Spinner animation="border" size="sm" role="status" className="ml-1" />
                                </>
                            ) : (
                                t('brand.campaign.discovery.export_page')
                            )}
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};
export default DiscoveryTotalsSection;
